import { onScroll } from '../../utils/on-scroll';

const HEIGHT_OFFSET = 400;

const isInViewport = windowHeight => element => {
    const isElementNearViewport =
        element.getBoundingClientRect().top <= windowHeight + HEIGHT_OFFSET;
    return isElementNearViewport;
};

export const lazyLoadImages = className => {
    // eslint-disable-next-line
    const unsubscribe = onScroll(loadImages);
    function loadImages() {
        const windowHeight = window.innerHeight;
        const elements = document.querySelectorAll(`.${className}`);
        if (elements.length === 0) {
            unsubscribe();
        }
        Array.from(elements)
            .filter(isInViewport(windowHeight))
            .forEach(element => {
                element.classList.remove(className);
                const url = element.dataset.src;
                element.removeAttribute('data-src');
                element.src = url;
            });
    }
    loadImages();
};
